import styled from 'styled-components';
import { TextStyle } from 'components/text';

export const Main = styled.div`
  clear: both;
  page-break-inside: avoid;
  page-break-after: always;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  max-width: 10cm;
  max-height: 100vh;
  padding: 30px;
  gap: 20px;

  ${TextStyle} {
    text-align: justify;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  border-top: 1px solid;
  width: 85%;
  margin-top: 20px;
`;
